import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';

import { Button, DetailPageLayout } from 'src/components/common';
import { PeosDetailsStaffTable } from 'src/components/peo/PeosDetailsStaffTable';
import { ModalId } from 'src/constants/modals';
import { usePeoParamId } from 'src/hooks/peo';
import { useModal } from 'src/hooks/shared';
import { useCurrentUserPermissions } from 'src/hooks/user';
import { InvitePeoStaffByCVStaffModalArgs, PeoStaffViewDetailsModal } from 'src/modals/peoStaff';
import { InvitePeoStaffByPeoPayrollProviderModalArgs } from 'src/modals/peoStaff/InvitePeoStaffByPeoPayrollProvider';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PeoDetailStaffPage: React.FC = () => {
  const { openModal } = useModal();
  const peoId = usePeoParamId();
  const { isPeoPayrollProviderUser } = useCurrentUserPermissions();

  const handleInviteModalOpen = React.useCallback(() => {
    const args: InvitePeoStaffByCVStaffModalArgs | InvitePeoStaffByPeoPayrollProviderModalArgs = {
      peoId,
    };

    const modalId = isPeoPayrollProviderUser
      ? ModalId.InvitePeoStaffByPeoPayrollProviderModal
      : ModalId.InvitePeoStaffByCVStaffModal;

    openModal(modalId, args);
  }, [isPeoPayrollProviderUser, openModal, peoId]);

  return (
    <DetailPageLayout
      titleContent="Staff"
      topRightContent={
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleInviteModalOpen}
        >
          New
        </Button>
      }
    >
      <TableDataProvider>
        <PeosDetailsStaffTable peoId={peoId} />
      </TableDataProvider>

      <PeoStaffViewDetailsModal />
    </DetailPageLayout>
  );
};
